/* Blank apparel product page (sections/blanks-product.liquid).
   - Color swatches re-render the section for the chosen color through the
     section rendering API and swap the gallery / size table in place.
   - Per-size quantities are added as separate cart lines.
   - With "Add custom printing" on, the real custom-dtg-print variant(s) for
     the chosen placement and total quantity are added as extra lines, so
     checkout charges exactly what the summary shows. */
(function () {
  var root = document.querySelector('[data-blanks-product]');
  if (!root) return;
  var form = root.querySelector('[data-blanks-form]');
  var sectionId = root.getAttribute('data-section-id');
  var money = window.themeFormatMoney || function (c) { return '$' + (c / 100).toFixed(2); };

  var pricingEl = root.querySelector('[data-blanks-pricing]');
  var pricing = null;
  try { pricing = pricingEl ? JSON.parse(pricingEl.textContent) : null; } catch (e) { pricing = null; }
  var dtgMap = {};
  if (pricing) pricing.dtgVariants.forEach(function (v) { dtgMap[v.tier + '|' + v.bracket] = v; });

  var printToggle = root.querySelector('[data-blanks-print-toggle]');
  var printOptions = root.querySelector('[data-blanks-print-options]');
  var placementLabel = root.querySelector('[data-blanks-placement-label]');
  var submitBtn = root.querySelector('[data-blanks-submit]');
  var warning = root.querySelector('[data-blanks-warning]');
  var firstPlacement = root.querySelector('[data-blanks-placement]');
  var selectedPlacement = firstPlacement ? firstPlacement.getAttribute('data-blanks-placement') : null;
  var firstTurnaround = root.querySelector('[data-blanks-turnaround]');
  var selectedTurnaround = firstTurnaround ? firstTurnaround.getAttribute('data-blanks-turnaround')
    : (root.querySelector('[data-turnaround-selected]') || {}).textContent || '';

  function printingOn() { return !!(printToggle && printToggle.checked); }

  function rows() {
    return Array.prototype.map.call(root.querySelectorAll('[data-blanks-qty]'), function (input) {
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      return {
        input: input,
        id: input.getAttribute('data-variant-id'),
        size: input.getAttribute('data-size'),
        price: parseInt(input.getAttribute('data-price'), 10) || 0,
        max: input.hasAttribute('data-max') ? parseInt(input.getAttribute('data-max'), 10) : null,
        qty: qty
      };
    });
  }

  function printEntries(totalQty) {
    if (!printingOn() || !pricing || !selectedPlacement || !pricing.placements[selectedPlacement]) return [];
    var placement = pricing.placements[selectedPlacement];
    var idx = 0;
    pricing.breaks.forEach(function (b, i) { if ((totalQty || 1) >= b) idx = i; });
    var bracket = pricing.bracketLabels[idx];
    var out = [];
    if (dtgMap[placement.tier + '|' + bracket]) out.push(dtgMap[placement.tier + '|' + bracket]);
    if (placement.backTier && dtgMap[placement.backTier + '|' + bracket]) out.push(dtgMap[placement.backTier + '|' + bracket]);
    return out;
  }

  function sync() {
    var all = rows();
    var active = all.filter(function (r) { return r.qty > 0; });
    var total = active.reduce(function (s, r) { return s + r.qty; }, 0);
    var blanks = active.reduce(function (s, r) { return s + r.qty * r.price; }, 0);
    var printUnit = printEntries(total).reduce(function (s, e) { return s + e.price; }, 0);
    var printTotal = printUnit * total;
    var over = all.filter(function (r) { return r.max !== null && r.qty > r.max; });

    root.querySelector('[data-blanks-summary-sizes]').textContent = active.length ? active.map(function (r) { return (r.size || 'Qty') + ': ' + r.qty; }).join(', ') : '—';
    root.querySelector('[data-blanks-summary-qty]').textContent = total;
    root.querySelector('[data-blanks-summary-blanks]').textContent = money(blanks);
    var printRow = root.querySelector('[data-blanks-summary-print-row]');
    if (printRow) {
      printRow.hidden = !printingOn();
      root.querySelector('[data-blanks-summary-print]').textContent = total ? money(printTotal) + ' (' + money(printUnit) + ' each)' : money(0);
    }
    root.querySelector('[data-blanks-summary-total]').textContent = money(blanks + printTotal);

    if (warning) {
      warning.hidden = over.length === 0;
      warning.textContent = over.map(function (r) { return 'Only ' + r.max + ' left in ' + r.size + '.'; }).join(' ');
    }
    submitBtn.disabled = total === 0 || over.length > 0;
  }

  /* Quantity inputs (delegated: the table is re-rendered on color change). */
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-blanks-qty]')) sync();
  });

  /* Gallery thumbs (delegated for the same reason). */
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-blanks-thumb]');
    if (!thumb) return;
    var id = thumb.getAttribute('data-blanks-thumb');
    root.querySelectorAll('[data-blanks-slide]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-blanks-slide') === id); });
    root.querySelectorAll('[data-blanks-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  });

  /* Color swatches: fetch this section rendered for the new color. */
  root.querySelectorAll('[data-blanks-color]').forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var url = swatch.getAttribute('href');
      root.querySelectorAll('[data-blanks-color]').forEach(function (s) {
        s.classList.toggle('is-selected', s === swatch);
        if (s === swatch) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current');
      });
      root.classList.add('is-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          root.querySelectorAll('[data-blanks-swap]').forEach(function (el) {
            var fresh = doc.querySelector('[data-blanks-swap="' + el.getAttribute('data-blanks-swap') + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          history.replaceState(null, '', url);
          sync();
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { root.classList.remove('is-loading'); });
    });
  });

  /* Printing on/off. */
  if (printToggle) {
    printToggle.addEventListener('change', function () {
      if (printOptions) printOptions.hidden = !printToggle.checked;
      sync();
    });
  }

  root.querySelectorAll('[data-blanks-placement]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-blanks-placement]').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      selectedPlacement = btn.getAttribute('data-blanks-placement');
      if (placementLabel) placementLabel.textContent = btn.getAttribute('data-label');
      sync();
    });
  });

  root.querySelectorAll('[data-blanks-turnaround]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-blanks-turnaround]').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      selectedTurnaround = btn.getAttribute('data-blanks-turnaround');
      var label = root.querySelector('[data-turnaround-selected]');
      if (label) label.textContent = selectedTurnaround;
    });
  });

  /* Artwork dropzones (same markup as the regular product page). */
  var requiredArtwork = null;
  root.querySelectorAll('[data-artwork-dropzone]').forEach(function (zone) {
    var input = zone.querySelector('[data-artwork-file-input]');
    if (zone.hasAttribute('data-artwork-required')) requiredArtwork = input;
    function show(file) {
      if (!file) return;
      zone.querySelector('[data-artwork-file-name]').textContent = file.name;
      zone.querySelector('[data-artwork-dropzone-prompt]').hidden = true;
      zone.querySelector('[data-artwork-file-row]').hidden = false;
    }
    input.addEventListener('change', function () { show(input.files[0]); });
    ['dragenter', 'dragover'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.add('is-dragover'); });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.remove('is-dragover'); });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer.files && e.dataTransfer.files[0]) { input.files = e.dataTransfer.files; show(e.dataTransfer.files[0]); }
    });
  });
  var notes = root.querySelector('[data-artwork-notes]');
  var notesCount = root.querySelector('[data-artwork-notes-count]');
  if (notes && notesCount) notes.addEventListener('input', function () { notesCount.textContent = String(notes.value.length); });

  function resetForm() {
    root.querySelectorAll('[data-blanks-qty]').forEach(function (i) { i.value = 0; });
    root.querySelectorAll('[data-artwork-dropzone]').forEach(function (zone) {
      zone.querySelector('[data-artwork-dropzone-prompt]').hidden = false;
      zone.querySelector('[data-artwork-file-row]').hidden = true;
      zone.querySelector('[data-artwork-file-input]').value = '';
    });
    if (notes) { notes.value = ''; if (notesCount) notesCount.textContent = '0'; }
    sync();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var active = rows().filter(function (r) { return r.qty > 0; });
    if (!active.length) { window.alert('Please enter a quantity for at least one size.'); return; }
    if (printingOn() && requiredArtwork && requiredArtwork.files.length === 0) {
      window.alert('Please upload your front artwork, or switch printing off to buy the blank only.');
      requiredArtwork.closest('[data-artwork-dropzone]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!window.themeCart || !window.themeCart.addMultiple) return;

    var colorEl = root.querySelector('[data-blanks-swap="color-name"]');
    var placementName = placementLabel ? placementLabel.textContent : '';
    var total = active.reduce(function (s, r) { return s + r.qty; }, 0);
    var lines = active.map(function (r) {
      var fd = new FormData();
      fd.append('id', r.id);
      fd.append('quantity', r.qty);
      if (printingOn()) {
        fd.append('properties[Print Location]', placementName);
        if (selectedTurnaround) fd.append('properties[Turnaround]', selectedTurnaround);
        root.querySelectorAll('[data-artwork-file-input]').forEach(function (input) {
          if (input.files[0]) fd.append(input.name, input.files[0]);
        });
        if (notes && notes.value) fd.append('properties[Order Notes]', notes.value);
      }
      return fd;
    });
    printEntries(total).forEach(function (entry) {
      var fd = new FormData();
      fd.append('id', entry.id);
      fd.append('quantity', total);
      fd.append('properties[Print Service For]', root.getAttribute('data-product-title') + (colorEl ? ' – ' + colorEl.textContent : ''));
      fd.append('properties[Placement]', placementName);
      lines.push(fd);
    });

    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;
    window.themeCart.addMultiple(lines).then(function () {
      submitBtn.classList.remove('is-loading');
      resetForm();
    }).catch(function () {
      submitBtn.classList.remove('is-loading');
      submitBtn.disabled = false;
    });
  });

  sync();
})();
